import { Component } from "react";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { InfraLayout } from '../InfraLayout';
import { InfraEntities } from "../InfraEntities";
import { InfraRouterProps } from "../InfraRouterProps";

interface MessagingListPageProps extends NSARouterMakerResult, InfraRouterProps { }

export default class MessagingListPage extends Component<MessagingListPageProps>
{
    override render()
    {
        return (
            <InfraLayout
                {...this.props}
                pages={{
                    entity: InfraEntities.messaging(this.props),
                    list: {}
                }}
            >
                <></>
            </InfraLayout>
        );
    }
}